import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { apiClient } from '../../../shared/services/apiClient';
import './login.css';

export const VerifyEmailPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') ?? '';
    const type = searchParams.get('type') ?? '';
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!token) { setStatus('error'); setMessage('Missing verification token.'); return; }
        apiClient.get(`/auth/verify-email?token=${token}&type=${type}`)
            .then(res => { setMessage((res.data as { message: string }).message); setStatus('success'); })
            .catch(err => { setMessage(err.response?.data?.message ?? 'Verification failed.'); setStatus('error'); });
    }, [token, type]);

    return (
        <>
            <div className="login-wrapper">
                <div className="login-card" style={{ textAlign: 'center' }}>
                    {status === 'loading' && <p>Verifying your email…</p>}
                    {status === 'success' && (
                        <>
                            <h2 style={{ color: '#375623', marginBottom: 12 }}>Email Verified!</h2>
                            <p style={{ color: '#64748b', marginBottom: 24 }}>{message}</p>
                            <Link to="/login" className="login-btn" style={{ display: 'inline-block', textDecoration: 'none', padding: '12px 28px' }}>Go to Login</Link>
                        </>
                    )}
                    {status === 'error' && (
                        <>
                            <div className="login-error">{message}</div>
                            <div className="login-footer"><Link to="/forgot-password">Request a new link</Link></div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
